import React from "react";
import { isMobile } from "react-device-detect";
import { view } from "react-easy-state";
import { message } from "antd";

import Footer from "components/common/layouts/Footer";
import ContentLoader from "components/common/ContentLoader";
import QuestionDetails from "components/pages/students/questions/show/QuestionDetails";
import QuestionListSider from "components/pages/students/questions/show/QuestionListSider";

import globalStore from "store";

import QuestionsService from "services/students/questions.service";

class QuestionsShowPage extends React.Component {
  fetchData = async () => {
    const { questionId, chapterId, questionnaireId } = this.props.match.params;
    const pageState = globalStore.ui.students.questions.show;
    await QuestionsService.show({
      pageState,
      chapterId,
      questionnaireId,
      questionId,
    });
  };

  async componentDidMount() {
    await this.fetchData();
  }

  async componentDidUpdate(prevProps, prevState) {
    //TODO: fix this
  }

  goBack = () => {
    const { chapterId } = this.props.match.params;
    // this.props.history.push(`/chapters/${chapterId}/questionnaires/${questionnaireId}`)
    this.props.history.push(`/chapters/${chapterId}`);
  };

  renderQuestionContent() {
    const { chapterId } = this.props.match.params;
    const pageState = globalStore.ui.students.questions.show;
    const {
      question,
      chapterErrors,
      questionnaireErrors,
      questionErrors,
      API_QUESTIONS_SHOW_STATUS,
    } = pageState;

    if (!API_QUESTIONS_SHOW_STATUS) return <ContentLoader />;
    if (API_QUESTIONS_SHOW_STATUS === "pending") return <ContentLoader />;
    if (API_QUESTIONS_SHOW_STATUS === "rejected") return <ContentLoader />;

    if (chapterErrors) {
      message.destroy();
      message.error(chapterErrors);
      this.props.history.push("/courses");
      return;
    }

    if (questionnaireErrors) {
      message.destroy();
      message.error(questionnaireErrors);
      this.props.history.push(`/chapters/${chapterId}`);
      return;
    }

    if (questionErrors) {
      message.destroy();
      message.error(questionErrors);
      // this.props.history.push(`/chapters/${chapterId}/questionnaires/${questionnaireId}`)
      this.props.history.push(`/chapters/${chapterId}`);
      return;
    }

    return (
      <React.Fragment>
        <QuestionListSider goBack={this.goBack} />
        <QuestionDetails question={question} goBack={this.goBack} />
      </React.Fragment>
    );
  }

  componentWillUnmount() {
    globalStore.ui.students.questions.show = {
      selectedOptionIndices: [],
    };
  }

  render() {
    return (
      <div className={`page lecture-page ${isMobile ? "mobile" : ""}`}>
        {this.renderQuestionContent()}
        <Footer />
      </div>
    );
  }
}

export default view(QuestionsShowPage);
